import React, { useCallback, useState, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthContext from "../../contexts/AuthProvider";
const AddAttraction = ({ baseUrl, id, setAddAttraction }) => {
  const { t } = useTranslation("venue");
  const [name, setName] = useState(null);
  const [desc, setDesc] = useState(null);
  const [website, setWebsite] = useState('');
  const [file, setFile] = useState(null);
  const [Errors, setErrors] = useState(null);
  const [showValidation, setShowValidation] = useState(false);
  const navigate = useNavigate();
const { isAuthenticated } = useContext(AuthContext);

  const handleFileChange = () => (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
      const allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];
      
      const isValidMimeType = allowedTypes.includes(selectedFile.type);
      const fileName = selectedFile.name.toLowerCase();
      const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
      
      if (isValidMimeType && isValidExtension) {
        setFile(selectedFile);
        setShowValidation(false); // Clear validation error when valid file is selected
      } else {
        setFile(null);
        setShowValidation(true); // Show validation error for invalid file
      }
    } else {
      setFile(null);
    }
  };
   const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  const onDropLogo = useCallback(
    (acceptedFiles, rejectedFiles) => {
      if (acceptedFiles.length > 0) {
        handleFileChange()({ target: { files: acceptedFiles } });
      } else if (rejectedFiles.length > 0) {
        setFile(null);
        setShowValidation(true); // Show validation error for rejected files
      }
    },
    [handleFileChange]
  );

  const { getRootProps: getRootPropsLogo } = useDropzone({
    onDrop: onDropLogo,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/gif': ['.gif'],
      'image/webp': ['.webp']
    },
  });

  const isValidName = () => name && name.trim().length > 2;
  const isWebsite = () => {
    const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}\/?$/;
    return websiteRegex.test(website) || website === '';
  };
  const isValidFile = () => {
    if (!file) return false;
    const allowedTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
    const allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];
    
    // Check MIME type
    const isValidMimeType = allowedTypes.includes(file.type);
    
    // Check file extension
    const fileName = file.name.toLowerCase();
    const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
    
    return isValidMimeType && isValidExtension;
  };

  const addAttraction = async () => {
    setShowValidation(true);
    if (!(isWebsite() && isValidName() && desc && desc.trim().length >= 10 && isValidFile())) return;

    const loadingToast = toast.loading(t('toast.processing'));
    try {
      if (!isAuthenticated) {
        throw new Error(t('errors.noToken'));
      }

      let formData = new FormData();
      formData.append('venue_id', id);
      formData.append('name', name);
      website && formData.append('url', website);
      formData.append('description', desc);
      formData.append('image', file);

      const url = `${baseUrl}/api/v1/attnd-venue/addLocalAttraction`;
      const response = await fetch(url, {
        method: 'POST',
        credentials: "include",
        headers: {
          lang: getLangFromLocalStorage(),
        },
        body: formData,
      });

      if (!response.ok) {
        if (response.status === 401) {
          navigate('/login');
          throw new Error(t('errors.unauthorized'));
        }

        const error = await response.json();
        setErrors(error);
        const errorMessage =
          error.error ||
          error.errors?.[0]?.name ||
          error.errors?.[0]?.url ||
          error.errors?.[0]?.description ||
          error.errors?.[0]?.image ||
          t('errors.unknown');
        throw new Error(errorMessage);
      }

      await response.json();
      toast.update(loadingToast, {
        render: t('toast.success'),
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
      setAddAttraction(false);
    } catch (error) {
      console.error(error);
      toast.update(loadingToast, {
        render: t('toast.error', { message: error.message }),
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <div className="addAttraction">
      <div className="AttractionContent">
        <h3>{t('title')}</h3>

        <div className="AttractionContent-name">
          <h5>
            {t('fields.siteName')} <span style={{ color: 'red' }}>*</span>
          </h5>
          <div>
            <input
              type="text"
              value={name}
              placeholder={t('placeholders.siteName')}
              onChange={(e) => setName(e.target.value)}
              style={
                !Errors?.errors?.[0]?.name && (isValidName() || name === null)
                  ? {}
                  : { borderColor: 'red' }
              }
            />
            {(Errors?.errors?.[0]?.name || !(isValidName() || name === null)) && (
              <p style={{ fontSize: '12px', color: 'red' }}>
                {Errors?.errors?.[0]?.name || t('validation.name')}
              </p>
            )}
          </div>
        </div>

        <div className="AttractionContent-name">
          <h5>
            {t('fields.description')} <span style={{ color: 'red' }}>*</span>
          </h5>
          <div className="description">
            <textarea
              className="desc"
              value={desc}
              placeholder={t('placeholders.description')}
              onChange={(e) => setDesc(e.target.value)}
              style={
                !Errors?.errors?.[0]?.description &&
                ((desc && desc.trim().length >= 10) || desc === null)
                  ? {}
                  : { borderColor: 'red' }
              }
            />
            {(Errors?.errors?.[0]?.description || !(
              (desc && desc.trim().length >= 10) || desc === null
            )) && (
              <p style={{ fontSize: '12px', color: 'red' }}>
                {Errors?.errors?.[0]?.description || t('validation.description')}
              </p>
            )}
          </div>
        </div>

        <div className="AttractionContent-name">
          <h5>{t('fields.website')}</h5>
          <div>
            <input
              type="text"
              value={website}
              placeholder={t('placeholders.website')}
              onChange={(e) => setWebsite(e.target.value)}
              style={
                !Errors?.errors?.[0]?.url && isWebsite()
                  ? {}
                  : { borderColor: 'red', outline: 'red' }
              }
            />
            {(Errors?.errors?.[0]?.url || (showValidation && !isWebsite())) && (
              <p style={{ fontSize: '12px', color: 'red' }}>
                {Errors?.errors?.[0]?.url || t('validation.website')}
              </p>
            )}
          </div>
        </div>

        <div className="AttractionContent-name">
          <h5 className="eventPage-form-title">
            {t('fields.uploadPhoto')} <span style={{ color: 'red' }}>*</span>
          </h5>
          <label 
            className="photo-input-label" 
            {...getRootPropsLogo()}
          >
            <div className="photo-input-box">
              <p>
                {!file && <>{t('dropzone.instruction')} </>}
                <span style={!file ? { marginLeft: '4px', textDecoration: 'underline' } : {}}>
                  {file ? file.name : t('dropzone.browse')}
                </span>
              </p>
              <input
                style={{ display: 'none' }}
                className="photo-input"
                type="file"
                name="logo"
                accept=".png,.jpg,.jpeg,.gif,.webp"
                onChange={handleFileChange()}
                required
              />
            </div>
            {/* SVGs below unchanged */}
            <svg style={{ minWidth: '24px', minHeight: '24px' }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75H15C20.43 22.75 22.75 20.43 22.75 15V9C22.75 3.57 20.43 1.25 15 1.25ZM9 21.25C4.39 21.25 2.75 19.61 2.75 15V9C2.75 4.39 4.39 2.75 9 2.75H15C19.61 2.75 21.25 4.39 21.25 9V15C21.25 19.61 19.61 21.25 15 21.25H9Z" fill="#5507CF"/>
              <path d="M11.9995 8.73981C11.8095 8.73981 11.6195 8.80981 11.4695 8.95981L8.46945 11.9598C8.17945 12.2498 8.17945 12.7298 8.46945 13.0198C8.75945 13.3098 9.23945 13.3098 9.52945 13.0198L11.9995 10.5498L14.4695 13.0198C14.7595 13.3098 15.2395 13.3098 15.5295 13.0198C15.8195 12.7298 15.8195 12.2498 15.5295 11.9598L12.5295 8.95981C12.3795 8.80981 12.1895 8.73981 11.9995 8.73981Z" fill="#5507CF"/>
              <path d="M12 8.74023C11.59 8.74023 11.25 9.08023 11.25 9.49023V17.4902C11.25 17.9002 11.59 18.2402 12 18.2402C12.41 18.2402 12.75 17.9002 12.75 17.4902V9.49023C12.75 9.07023 12.41 8.74023 12 8.74023Z" fill="#5507CF"/>
              <path d="M12.0004 5.76984C9.89043 5.76984 7.77043 6.10984 5.76043 6.77984C5.37043 6.90984 5.16043 7.33984 5.29043 7.72984C5.42043 8.11984 5.84043 8.33984 6.24043 8.19984C9.96043 6.95984 14.0504 6.95984 17.7704 8.19984C18.1604 8.32984 18.5904 8.11984 18.7204 7.72984C18.8504 7.33984 18.6404 6.90984 18.2504 6.77984C16.2304 6.09984 14.1104 5.76984 12.0004 5.76984Z" fill="#5507CF"/>
            </svg>
          </label>
          {(Errors?.errors?.[0]?.image || (showValidation && !isValidFile())) && (
            <p style={{ fontSize: '12px', color: 'red' }}>
              {Errors?.errors?.[0]?.image || t('validation.photo')}
            </p>
          )}
        </div>

        <div className="Buttons">
          <button onClick={() => setAddAttraction(false)} className="Cancel">
            {t('buttons.cancel')}
          </button>
          <button
            className="confirm"
            onClick={addAttraction}
            disabled={!(isWebsite() && isValidName() && desc && desc.trim().length >= 10 && isValidFile())}
            style={
              isWebsite() && isValidName() && desc && desc.trim().length >= 10 && isValidFile()
                ? {}
                : { background: '#888888', cursor: 'not-allowed' }
            }
          >
            {t('buttons.add')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAttraction;